export const API_URL = 'https://apilexnetppd.lefebvre.es/api'
export const APP_FAKE = false
export const PARTNER_ID = 'd3f74cf0-a285-422e-816f-61f41804850c'
export const LEXON_API_URL = 'https://api.lex-on.es'
export const LEXON_URL = 'https://front.lex-on.es'
export const LEXNET_COOKIE_NAME = 'lexnet_session'
export const LEXNET_COOKIE_TIMEOUT = 15 // Minute
export const SHOW_FORM_ALWAYS = false
export const MY_ACCOUNT_URL = 'https://areapersonal.lefebvre.es/login/dashboard/'
// COOKIEBOT
export const APP_COOKIEBOT_URL = 'https://consent.cookiebot.com/uc.js'
export const APP_COOKIEBOT_ID = 'bb0d601e-f391-4331-aee8-dc7e51d1538b'
export const APP_COOKIEBOT_URL_TEXTS =
  'https://consent.cookiebot.com/bb0d601e-f391-4331-aee8-dc7e51d1538b/cd.js'

// CLARITY
export const APP_CLARITY_ID = 'qys427ui2y'